import { useAppSelector } from '../../store';

/**
 * Pure utility — returns testDate as a Date when set, otherwise real current time.
 * Use this in pure functions (non-hooks) by passing state.testContext.testDate.
 */
export const getNow = (testDate: string | null): Date => {
  return testDate ? new Date(testDate) : new Date();
};

/**
 * Hook — returns the effective current date, respecting any active test date context.
 * Use this in React components and hooks instead of new Date() directly.
 */
export const useNow = (): Date => {
  const testDate = useAppSelector((state) => state.testContext.testDate);
  return getNow(testDate);
};
